import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/organizations/$advisoryOrganizationId/')(
  {
    beforeLoad: ctx => {
      throw redirect({
        params: ctx.params,
        replace: true,
        to: '/organizations/$advisoryOrganizationId/plans'
      });
    }
  }
);
